import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#44403C",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.67",
      d: "M19 18v-1.778c0-.943-.361-1.847-1.004-2.514a3.368 3.368 0 0 0-2.425-1.041H10.43c-.91 0-1.782.374-2.425 1.041A3.623 3.623 0 0 0 7 16.222V18m9.429-12.444c0 1.963-1.535 3.555-3.429 3.555-1.893 0-3.429-1.592-3.429-3.555C9.571 3.592 11.107 2 13 2c1.893 0 3.429 1.592 3.429 3.556Z"
    }, null, -1)
  ]))]))
}
export default { render: render }